module.exports = __webpack_public_path__ + "static/media/Envios_LotesColoca.ff1ce9ad.xlsm";